import { BACKGROUND_COLOR_CODE_MAP } from './bgColorMap.mjs';

const BI_BACKGROUND_INFO = {
  BK_KB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  BK_SHINHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  BK_HANA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  BK_WOORI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  BK_KAKAO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KAKAO
  },
  BK_K: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.K
  },
  BK_IBK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IBK
  },
  BK_NH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  BK_KDB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KDB
  },
  BK_SC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SC
  },
  BK_BUSAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  BK_DAEGU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IM
  },
  BK_KYOUNGNAM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  BK_SH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SH
  },
  BK_KWANGJU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JB
  },
  BK_JEONBUK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JB
  },
  BK_JEJU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  BK_EPOST: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.EPOST
  },
  BK_TOSS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.TOSS
  },
  BK_HF: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HF
  },
  BK_KOSAF: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KOSAF
  },
  BK_KINFA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KINFA
  },
  BK_KFCC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KFCC
  },
  BK_CU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CU
  },
  BK_SHCENTRAL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SH
  },
  BK_NHCENTRAL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NHCENTRAL
  },
  BK_CITI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CITI
  },
  BK_EXIM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.EXIM
  },
  BK_HSBC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HSBC
  },
  BK_NFCF: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NFCF
  },
  BK_DEUTSCH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DEUTSCH
  },
  BK_BOA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BOA
  },
  BK_BNP: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNP
  },
  BK_JPMORGAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JPMORGAN
  },
  BK_ICBC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.ICBC
  },
  BK_CHINA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CHINA
  },
  BK_CCB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CCB
  },
  BK_K_NPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.K
  },
  BK_SHINHAN_NPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  IV_MIRAE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MIRAE
  },
  IV_KIWOOM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KIWOOM
  },
  IV_KB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  IV_SAMSUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SAMSUNG
  },
  IV_KOREA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KOREAINVEST
  },
  IV_SHINHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  IV_NH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  IV_HANA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  IV_DAISHIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DAISHINIV
  },
  IV_KAKAOPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KAKAOIV
  },
  IV_TOSS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.TOSS
  },
  IV_MERITZ: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MERITZ
  },
  IV_YUANTA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.YUANTA
  },
  IV_KYOBO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KYOBO
  },
  IV_EUGENE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.EUGENE
  },
  IV_HM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HM
  },
  IV_DBFI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DBFI
  },
  IV_HI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DGB
  },
  IV_LS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LS
  },
  IV_HANWHA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANWHA
  },
  IV_SK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SK
  },
  IV_DAOL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DAOL
  },
  IV_SHINYOUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINYOUNG
  },
  IV_IBK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IBK
  },
  IV_FOSS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  IV_WOORI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  IV_HANKUK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANKUK
  },
  IV_KTB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DAOL
  },
  IV_BNK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  IV_BOOKOOK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BOOKOOK
  },
  IV_CAPE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CAPE
  },
  IV_DS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DS
  },
  IV_HANYANG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANYANG
  },
  IV_HEUNGKUK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HEUNGKUK
  },
  IV_KOREAASSET: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KOREAASSET
  },
  IV_KR: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KR
  },
  IV_LEADING: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LEADING
  },
  IV_MACQUARIE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BLACK
  },
  IV_SSIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SSIN
  },
  IV_YUHWA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.YUHWA
  },
  IV_NAVER_MIRAE: {
    backgroundColor: '',
    backgroundImage: 'linear-gradient(180deg, #479F8F 0%, #377ED4 100%)'
  },
  CD_SHINHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  CD_SAMSUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SAMSUNG
  },
  CD_KB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  CD_HYUNDAI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CD_HYUNDAI
  },
  CD_BC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BC
  },
  CD_HANA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  CD_WOORI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  CD_LOTTE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LOTTE
  },
  CD_NH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  CD_IBK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IBK
  },
  CD_SC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SC
  },
  CD_KDB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KDB
  },
  CD_KFCC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KFCC
  },
  CD_EPOST: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.EPOST
  },
  CD_CU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CU
  },
  CD_SH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SH
  },
  CD_DAEGU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IM
  },
  CD_KWANGJU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JB
  },
  CD_BUSAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  CD_KYOUNGNAM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  CD_JEONBUK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JB
  },
  CD_HYUNDAI_DS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CD_HYUNDAI_DS
  },
  CD_GALLERIA_DS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CD_GALLERIA_DS
  },
  CD_K_BANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.K
  },
  CD_KAKAO_BANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KAKAO
  },
  CD_JEJU_BANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  CD_CITI_BANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CITI
  },
  CD_TOSS_BANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.TOSS
  },
  CD_MIRAE_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MIRAE
  },
  CD_KB_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  CD_HANKOOK_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CD_KOREAINVEST
  },
  CD_NH_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CD_NH
  },
  CD_YUANTA_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.YUANTA
  },
  CD_SK_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SK
  },
  CD_HANWHA_STOCK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANWHA
  },
  CD_NAVER_PAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NAVERPAY
  },
  CD_KAKAO_PAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KAKAO
  },
  SB_COMMON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.FSB
  },
  SB_SMART: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_TRUE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_CENTRAL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DOUBLE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DONGYANG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DONGYANGSB
  },
  SB_DAEHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_KOREAINVEST: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KOREAINVEST
  },
  SB_STAR: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_MS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DAEBAEK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DAEBAEK
  },
  SB_UNION: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DAEAH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DAISHIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DAISHIN
  },
  SB_SAMHO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_OHTOO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.OHTOO
  },
  SB_ASAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_SSINPLUS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SSIN
  },
  SB_WOORIFIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  SB_CK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_THEK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_KIWOOMYES: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KIWOOM
  },
  SB_KB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  SB_BARO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BARO
  },
  SB_YUANTA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.YUANTA
  },
  SB_OK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.OK
  },
  SB_MUSTSAMIL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MUSTSAMIL
  },
  SB_DONGWONJEIL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DONGWONJEIL
  },
  SB_OHSUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_BNK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  SB_DAEWON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DAEMYUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_HANSUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_CHUNGJU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_KIWOOM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KIWOOM
  },
  SB_DREAM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_SOLBRAIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_JINJU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_CHOHEUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_IBK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IBK
  },
  SB_SNT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_WOORI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_COREA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_KOOKJE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KOOKJE
  },
  SB_HEUNGKUK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_RAON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.RAON
  },
  SB_PURUN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_ANYANG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_PEPPER: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.PEPPER
  },
  SB_KUMHWA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_WELCOME: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_SHINHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  SB_JTCHINE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_NH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  SB_ACUON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.ACUON
  },
  SB_HB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HB
  },
  SB_OSB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_YEKARAM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_HANA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  SB_SBI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SBI
  },
  SB_SBI2: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SBI
  },
  SB_DB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_SKY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_PYUNGTAEK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_MK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MK
  },
  SB_CHOEUN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_YOONGCHANG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_NAMYANG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NAMYANG
  },
  SB_INSUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_MOA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_INCHEON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_HANWHA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANWHA
  },
  SB_YOUNGJIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_JT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JT
  },
  SB_ANGUK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_SSIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SSIN
  },
  SB_SERAM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_SAMJUNG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_BOORIM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  SB_DAOL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DAOL
  },
  SB_LENDIT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LENDIT
  },
  IS_SAMSUNGFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_HI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IS_HI
  },
  IS_DBFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_KBFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  IS_MERITZFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MERITZ
  },
  IS_AXA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.AXA
  },
  IS_HANWHAFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANWHA
  },
  IS_NHFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  IS_HANAFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_LOTTE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_AIGFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.AIG
  },
  IS_HEUNGKUKFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HEUNGKUK
  },
  IS_CARROT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CARROT
  },
  IS_MG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KFCC
  },
  IS_BNPFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNP
  },
  IS_LINAFIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_SAMSUNGLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SAMSUNG
  },
  IS_HANWHALIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANWHA
  },
  IS_KYOBOLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_SHINHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  IS_LINALIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LINA
  },
  IS_NHLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  IS_DONGYANG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_AIGLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.AIA
  },
  IS_MIRAE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MIRAE
  },
  IS_HEUNGKUKLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HEUNGKUK
  },
  IS_FUBON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_ABL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.ABL
  },
  IS_KDB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KDB
  },
  IS_DGB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.DGB
  },
  IS_MET: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_DBLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_KB_PRUDENTIAL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  IS_HANALIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  IS_CHUBBLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_LIFEPLANET: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_BNPLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNP
  },
  IS_SGIC: {
    backgroundColor: ''
  },
  IS_KOREAPOST: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.EPOST
  },
  IS_IBKI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IBK
  },
  IS_THEK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  IS_KAKAO_PAY_FIRE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KAKAOFIRE
  },
  CAPITAL_HYUNDAI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CAPITAL_HYUNDAI
  },
  // 현대캐피탈
  CAPITAL_KB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  // KB캐피탈
  CAPITAL_HANA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  // 하나캐피탈
  CAPITAL_WOORIF: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  // 우리금융캐피탈
  CAPITAL_NH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.NH
  },
  // NH농협캐피탈
  CAPITAL_LOTTE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LOTTE
  },
  // 롯데캐피탈
  CAPITAL_BNK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  // BNK캐피탈
  CAPITAL_MERITZ: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MERITZ
  },
  // 메리츠캐피탈
  CAPITAL_JB_WOORI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.JB
  },
  // JB우리캐피탈
  CAPITAL_KDBC: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KDB
  },
  // 산은캐피탈
  CAPITAL_ORIX: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 오릭스캐피탈
  CAPITAL_DGB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IM
  },
  // 디지비캐피탈
  CAPITAL_M: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 엠캐피탈
  CAPITAL_K_CAR: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 케이카캐피탈
  CAPITAL_HANKOOK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 한국캐피탈
  CAPITAL_ACUON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.ACUON
  },
  // 애큐온캐피탈
  CAPITAL_CNH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CNH
  },
  // 씨앤에이치캐피탈
  CAPITAL_SHINHAN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  // 신한캐피탈
  CAPITAL_A: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 에이캐피탈
  CAPITAL_HB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // HB캐피탈
  CAPITAL_OK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.OK
  },
  CAPITAL_SY: {
    backgroundColor: ''
  },
  // SY오토캐피탈
  CAPITAL_DB: {
    backgroundColor: ''
  },
  // 디비캐피탈
  CAPITAL_ECO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.ECO
  },
  // 에코캐피탈
  CAPITAL_WELCOME: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 웰컴캐피탈
  CAPITAL_MASON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MASON
  },
  // 메이슨캐피탈
  CAPITAL_MOORIM: {
    backgroundColor: ''
  },
  // 무림캐피탈
  CAPITAL_KICF: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KICF
  },
  // 한국투자캐피탈
  CAPITAL_MIRAE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MIRAE
  },
  // 미래에셋캐피탈
  CAPITAL_KIWWOOM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CAPITAL_KIWWOOM
  },
  // 키움캐피탈
  CAPITAL_IBK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.IBK
  },
  // IBK캐피탈
  CAPITAL_BMW: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // BMW파이낸셜
  CAPITAL_HYUNDAI_COMMERCIAL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.CAPITAL_HYUNDAI_COMMERCIAL
  },
  // 현대커머셜
  CAPITAL_MERCEDES_BENZ: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 벤츠파이낸셜
  CAPITAL_RCI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 알씨아이파이낸셜
  CAPITAL_VOLKSWAGEN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.VOLKSWAGEN
  },
  // 폭스바겐파이낸셜
  CAPITAL_PORSCHE: {
    backgroundColor: ''
  },
  // 포르쉐파이낸셜
  CAPITAL_LOTTE_AUTOLEASE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 롯데오토리스
  CAPITAL_TOYOTA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.TOYOTA
  },
  // 토요타파이낸셜
  CAPITAL_VOLVO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 볼보파이낸셜
  CAPITAL_DEUTSCH: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 도이치파이낸셜
  CAPITAL_SHINHAN_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SHINHAN
  },
  // 신한카드
  CAPITAL_KB_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.KB
  },
  // KB국민카드
  CAPITAL_WOORI_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WOORI
  },
  // 우리카드
  CAPITAL_SAMSUNG_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.SAMSUNG
  },
  // 삼성카드
  CAPITAL_HANA_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.HANA
  },
  // 하나카드
  CAPITAL_LOTTE_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.LOTTE
  },
  // 롯데카드
  CAPITAL_BC_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BC
  },
  // 비씨카드
  CAPITAL_KN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.BNK
  },
  // 경남은행
  CAPITAL_PEOPLE_FUND: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 피플펀드
  CAPITAL_8PERCENT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  CAPITAL_HONESTFUND: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  TEL_SKT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // SKT
  TEL_KT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // KT
  TEL_LGU: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // LG유플러스
  TEL_SKB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // SK브로드밴드
  TEL_HELLOVISION: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // LG헬로비전
  TEL_SKYLIFE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // KT스카이라이프
  TEL_DLIVE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 딜라이브
  TEL_CMB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // CMB
  TEL_KTM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 케이티엠모바일
  TEL_HCN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 현대HCN
  TEL_U: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // U+알뜰모바일
  TEL_SK7: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // SK텔링크
  TEL_LIIVM: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 리브모바일
  TEL_TOSS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 토스모바일
  TEL_FINDIRECT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 핀다이렉트
  TEL_S1: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 안심모바일
  TEL_A: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 에이모바일
  TEL_KCT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 한국케이블텔레콤
  TEL_SEJONG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 세종텔레콤
  TEL_FREET: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 프리티 (프리텔레콤)
  TEL_JCN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // JCN울산중앙방송
  TEL_KONAI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 코나아이
  TEL_MOBING: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 모빙
  TEL_EYES: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 아이즈모바일
  TEL_NIB: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 남인천방송
  TEL_INSCOBEE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 프리티 (인스코비)
  TEL_ACN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // ACN코리아
  TEL_EG: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 이지모바일
  TEL_KPMO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 한국피엠오
  TEL_YLLAND: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 와이엘랜드
  TEL_COINSHOT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 코인샷
  TEL_WINNERSTEL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 위너스텔
  TEL_ONKUKMIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 온국민폰
  TEL_SMARTEL: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 스마텔
  TEL_EYAGI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  // 이야기모바일
  ORG_KFTC: {
    backgroundColor: ''
  },
  ORG_KOSCOM: {
    backgroundColor: ''
  },
  ORG_SIGNGATE: {
    backgroundColor: ''
  },
  /**
   * TODO: 포인트 업권 대응 필요
   */
  POINT_11STREET: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_DGBUPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_KGMOBILLIANCE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_OKINVESTMENTPARTNERS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_OKCASHBACK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_PAYCO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_SKCOMMUNICATIONS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_SMHIPLUS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_SSGPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_GOLFZONE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_GOOGLEPAYMENTKOREA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_GLOBALMONEYEXPRESS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_NAVERPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_CARROTPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_DECNCOMASSETMANAGEMENT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_LOKAMOBILITY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_LOTTESHOPPING: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_MYBI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_BAEMIN: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_BANKSALAD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_BUSANHANAROCARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_BLUEWALNUT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_SETTLEBANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_SMILEPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_LPOINT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_WELCOMEPAYMENTS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_WEMAKEPRICE: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_INTERPARK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_KAKAO: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_KAKAOBANK: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_KAKAOPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_KONAI: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_COOCON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_COUPANGPAY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_TOSSPAYMENTS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_TOSSPOINTS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_TRAVELWALLET: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_TMONEY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_TIMON: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_FINSHOT: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_FINNQ: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_HANAMONEY: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_KOREAPREPAIDCARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  POINT_HANPAYSYS: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.WHITE
  },
  CD_VISA: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.VISA
  },
  CD_MASTER_CARD: {
    backgroundColor: BACKGROUND_COLOR_CODE_MAP.MASTER_CARD
  }
};

export { BI_BACKGROUND_INFO };
